import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const submit: ThemedFunctor = () => css`
  display: flex;
  height: 100%;
  align-items: flex-end;
`;
